import { ApiRequest } from "../api/request";
import { ENVIRONMENTS } from "./env.constants";
import _ from "lodash";

export default class ConfigService extends ApiRequest {
	constructor($http, $q, appCache) {
		"ngInject";
		super({ $http, $q, appCache });
	}

	storeConfig(config) {
		this.appCache.set("config", config);
	}

	getConfig() {
		return this.appCache.get("config");
	}

	fetchLegalContent(tenant, document) {
		// lodash transforms BANK99 to bank-99, which is wrong.
		// it should be bank99, do not treat transition from letter to captial as position to place -
		const loweredKebab = _.kebabCase(tenant).replace(/-(\d)/g, "$1");

		return this.$http({
			url: `https://tenants.fino.cloud/conf/dws/${loweredKebab}/${document}`,
		});
	}

	get config() {
		return this.getConfig();
	}

	getPlausibleHost() {
		switch (this.getStage()) {
			case ENVIRONMENTS.DEV:
				return "https://plsbl.test.fino.cloud/";
			case ENVIRONMENTS.TESTING:
				return "https://plsbl.test.fino.cloud/";
			default:
				return "https://plsbl.fino.cloud/";
		}
	}

	getStage() {
		// eslint-disable-next-line angular/window-service
		const host = window.location.host;
		if (host.includes("localhost") || host.includes(".dev")) {
			return ENVIRONMENTS.DEV;
		} else if (host.includes(".test")) {
			return ENVIRONMENTS.TESTING;
		} else {
			return ENVIRONMENTS.PRODUCTION;
		}
	}

	isDevelopment() {
		return this.getStage() === ENVIRONMENTS.DEV;
	}

	isTesting() {
		return this.getStage() === ENVIRONMENTS.TESTING;
	}

	isProduction() {
		return this.getStage() === ENVIRONMENTS.PRODUCTION;
	}

	getName() {
		if (!this.config) return null;
		return this.config.name;
	}

	getTenant() {
		if (!this.config) return "";
		return this.config.tenant;
	}

	getCountryCode() {
		if (!this.config) return "DE";
		return this.config.countryCode;
	}

	isAustrianTenant() {
		return "AT" === this.getCountryCode();
	}

	isBank99() {
		return "BANK99" === this.getTenant();
	}

	isConsorsbank() {
		return this.getTenant().includes("CONSORSBANK");
	}

	isPSD() {
		return this.getTenant().includes("PSD");
	}

	isFeatureActive(feature) {
		return !!this.getFeature(feature);
	}

	getFeature(feature) {
		if (!this.config) return false;
		return this.config.features[feature];
	}

	$get() {
		return this;
	}
}



// WEBPACK FOOTER //
// ./src/app/common/config/config.service.js